import React, { useState } from 'react';

import { FormEstacionamento } from '../../components/FormEstacionamento';
import { ErrorRetrievingData } from '../../components/ErrorRetrievingData';

import MenuMain from '../../MenuMain';
import { AppFooter } from '../../AppFooter';


export default function EditarEstacionamentoPage(props) {

    const [estacionamento, setEstacionamento] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [errorGettingEstacionamento, setErrorGettingEstacionamento] = useState(false)
    const [errorMessage, setErrorMessage] = useState('');

    return (
        <>
            <MenuMain >

                {
                    errorGettingEstacionamento ?
                        <ErrorRetrievingData
                            errorMessage={errorMessage}
                            isLoading={isLoading}
                        />
                        :
                        
                        <FormEstacionamento
                            isLoading={isLoading}
                            isEditing={true}
                        />
                        
                }
            </MenuMain>
            <AppFooter />
        </>
    );
}